import { skipToken, useMutation, useQuery } from '@tanstack/react-query';

import api from '../../services/api';

interface Response {
  lead:
    | {
      id: number;
      gid: string;
    }
    | undefined;
}

export const getLastLeadId = (personGid: string): Promise<Response> =>
  api.get(`/api/frontend/people/${personGid}/last_lead_id`);

export const useGetLastLeadId = () =>
  useMutation({
    mutationFn: getLastLeadId
  });

const useLastLeadId = (personGid: string | undefined) =>
  useQuery({
    queryKey: ['last_lead_id', personGid],
    queryFn: personGid ? () => getLastLeadId(personGid) : skipToken,
    select: data => data.lead
  });

export default useLastLeadId;
